import { render, staticRenderFns } from "./ModalInvoicePayments.vue?vue&type=template&id=8516600c&"
import script from "./ModalInvoicePayments.vue?vue&type=script&lang=js&"
export * from "./ModalInvoicePayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports